import { RegistrationDataT, RegistrationRequestT } from '../../types';
import { SerializeT } from '../../types/transform';
import { addressTransform } from '../address/address';
import { serializeMaritalInformation } from '../marital-information/serialize-marital-information';

export const serializeRegistration: SerializeT<Partial<RegistrationDataT>, RegistrationRequestT> = (account) => {
  const address = account.address && addressTransform.serialize(account.address);
  const maritalInformation = account.maritalInformation && serializeMaritalInformation(account.maritalInformation);

  return {
    ...address,
    ...maritalInformation,
    ...(account.phoneNumber && { main_phone: account.phoneNumber }),
  };
};
